import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { SKIN_THEMES, FONT_UI } from "./constants";

export default function Layout({
  children,
  dashboardData = {},
  routePage,
  activePage = "",
  activeMenu = "",
}) {
  const navigate = useNavigate();

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [skinId, setSkinId] = useState(
    () => localStorage.getItem("skinTheme") || "navy"
  );

  const skin = SKIN_THEMES.find((s) => s.id === skinId) || SKIN_THEMES[0];

  const handleSkinChange = (id) => {
    setSkinId(id);
    localStorage.setItem("skinTheme", id);
  };

  const handleLogout = () => {
    [
      "token",
      "authToken",
      "isLoggedIn",
      "userData",
      "company_name",
      "licensedFor",
      "admin_active",
      "company_address",
      "company_phone",
      "admin_email",
      "company_logo",
      "user_map",
    ].forEach((k) => localStorage.removeItem(k));

    navigate("/");
  };

  return (
    <div
      className="min-h-screen bg-slate-50"
      style={{ fontFamily: FONT_UI }}
    >
      <Sidebar
        skin={skin}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        routePage={routePage || "/route-master"}
        onLogout={handleLogout}
        activePage={activePage}
        activeMenu={activeMenu}
      />

      <div className="min-h-screen flex flex-col lg:ml-[270px]">
        <Header
          skin={skin}
          skinId={skinId}
          onSkinChange={handleSkinChange}
          dashboardData={dashboardData || {}}
          onLogout={handleLogout}
          setSidebarOpen={setSidebarOpen}
        />

        <main className="flex-1 px-4 py-6 md:px-7 md:py-7">
          {children}
        </main>
      </div>
    </div>
  );
}